import { createSelector, createStructuredSelector } from 'reselect';
import get from 'lodash/get';

import { contact } from '../communication/entities';

import { findConversation } from './utils';

const selectChat = state => state.chat;

const getActiveConversationWith = createSelector(selectChat, state => state.activeConversationWith);
const chatSelectors = {
  isOpen: createSelector(selectChat, state => state.open),
  getActiveConversationWith,
  hasActiveConversation: createSelector(
    selectChat,
    state => !!findConversation(state.activeConversations, state.activeConversationWith)
  ),
  getActiveConversations: createSelector(selectChat, state => state.activeConversations),
  isConversationClosing: username =>
    createSelector(selectChat, state =>
      get(
        state.activeConversations.find(conv => conv.username === username),
        'closeCustomerChatPending',
        false
      )
    ),
  isConversationClosed: username =>
    createSelector(selectChat, state => !state.activeConversations.find(conv => conv.username === username)),
  hasInactivityWarning: createSelector(
    selectChat,
    state => (findConversation(state.activeConversations, state.activeConversationWith) || {}).hasInactivityWarning
  ),
  getUnopenedMessagesFrom: createSelector(selectChat, state => state.unopenedMessagesFrom),
  isPending: createSelector(selectChat, state => state.pending),
  getConversation: createSelector(selectChat, state => {
    return findConversation(state.activeConversations, state.activeConversationWith) || { messages: [] };
  }),
  getConversationByUser: userId =>
    createSelector(selectChat, state => {
      return findConversation(state.activeConversations, userId) || { messages: [] };
    }),
  getActiveContact: createSelector(
    state => state.communication.contact.list,
    getActiveConversationWith,
    (contacts, activeConversationWith) => contacts.find(entry => entry.id === activeConversationWith)
  ),
  getMessages: createSelector(selectChat, state => {
    return (findConversation(state.activeConversations, state.activeConversationWith) || { messages: [] }).messages;
  }),
  hasError: createSelector(selectChat, state => state.error != null),
  getError: createSelector(selectChat, state => state.error),
  getAgent: createSelector(selectChat, state => state.agent),
  isAgentCheckPending: createSelector(selectChat, state => state.checkAgentPending),
};

export default chatSelectors;
